<div class="container-fluid">
    <div class="row">
        <div class="col-md-12 five">
            <!--<h1>Product exclusion</h1>-->
        </div>
    </div>
    <form (ngSubmit)="onSubmit()" [formGroup]="productExclusionDetails" id="productExclusionDetails">
        <div class="row mt-3">
            <div class="col-lg-4 col-md-6 col-12 mb-3">
                <div class="form-floating">
                    <select class="form-select" formControlName="shopName" id="shopName" (change)="getShopId($event)">
                        <option value="" disabled>Select Shop Name</option>
                        <option *ngFor="let shop of shopList" [value]="shop.traderId">{{ shop.traderName }}</option>
                    </select>
                    <label for="shopName">Shop Name<span style="color:red;">*</span></label>
                </div>
                <span *ngIf="productExclusionErrors.shopname"
                      class="error-text">{{ productExclusionErrors.shopname }}</span>
            </div>

            <div class="col-lg-4 col-md-6 col-12 mb-3">
                <div class="form-floating">
                    <select class="form-select" formControlName="category" id="category"
                            (change)="selectCategory($event)">
                        <option value="" disabled>Select Product Category</option>
                        <option *ngFor="let category of mainCategoryList" [value]="category.catId">
                            {{ category.catName }}
                        </option>
                    </select>
                    <label for="category">Category<span style="color:red;">*</span></label>
                </div>
                <span *ngIf="productExclusionErrors.category"
                      class="error-text">{{ productExclusionErrors.category }} </span>
            </div>

            <div class="col-lg-4 col-md-6 col-12 mb-3">
                <div class="form-floating">
                    <select class="form-select" formControlName="subcategory" id="subcategory"
                            (change)="selectSubCategory($event)">
                        <option value="" disabled>Select Product Sub Category</option>
                        <option *ngFor="let sub of subCategory" [value]="sub.subCatId">
                            {{ sub.subCatName }}
                        </option>
                    </select>
                    <label for="subcategory">Sub Category<span style="color:red;">*</span></label>
                </div>
                <span *ngIf="productExclusionErrors.subcategory"
                      class="error-text">{{ productExclusionErrors.subcategory }}</span>
            </div>


            <!--<div class="col-md-3">
                <label>Product Name<span style="color:red;">*</span></label>
                <div class="">
                    <ng-multiselect-dropdown
                            (onDeSelect)="onItemDeSelect($event)"
                            (onSelect)="onItemSelect($event)"
                            (onSelectAll)="onSelectAll($event)"
                            [(ngModel)]="productItem"
                            [data]="productList"
                            [placeholder]="'Select Product'"
                            [settings]="DropDownSettings"
                            formControlName="productId"
                    >
                    </ng-multiselect-dropdown>
                </div>
            </div>-->
        </div>
        <!--<div class="row mt-3">
            <div class="col-6">
                <label>Click here to exclude the products</label>
                <div class="card card-design">
                    <div *ngIf="currentProductDetails.length > 0">
                        <div *ngFor="let product of currentProductDetails" class="row col-12">
                            <input class="form-check ml-2 col-1" style="align-self: start" type="checkbox"
                                   (change)="clickToRemove($event, product.productId)">
                            <span class="col-10">{{product.productName}}</span>
                        </div>
                    </div>
                    <div *ngIf="currentProductDetails.length == 0">
                        <span class="justify-content-center d-flex">No Data Found</span>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <label>Excluded products</label>
                <div class="card card-design">
                    <div *ngIf="removedProductDetails.length > 0">
                        <div *ngFor="let product of removedProductDetails; let i = index" class="row col-12">
                            <span class="ml-2">{{i + 1}}. {{product.productName}}</span>
                        </div>
                    </div>
                    <div *ngIf="removedProductDetails.length == 0">
                        <span class="justify-content-center d-flex">No Data Found</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-4"></div>
            <div class="col-md-4">
                <div class="" style="text-align: center;">
                    <button type="submit" class="btnColor">Click to Exclude</button>
                </div>
            </div>
        </div>-->


        <div class="row mt-3 mb-3">
            <div class="col-lg-6 col-12 mb-3">
                <div class="card direct-chat direct-chat-primary">
                    <div class="card-header ui-sortable-handle" style="cursor: move;">
                        <span class="text-danger">Note: Select products to remove from your shop</span>

                        <!--<div class="card-tools">
                            <span title="3 New Messages" class="badge badge-primary">3</span>
                            <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                <i class="fas fa-minus"></i>
                            </button>
                            <button type="button" class="btn btn-tool" title="Contacts" data-widget="chat-pane-toggle">
                                <i class="fas fa-comments"></i>
                            </button>
                            <button type="button" class="btn btn-tool" data-card-widget="remove">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>-->
                    </div>
                    <!-- /.card-header -->
                    <div class="card-body">
                        <!-- Conversations are loaded here -->
                        <div class="direct-chat-messages overflow-x-hidden">
                            <div *ngIf="!showEmptyError">
                                <div class="direct-chat-msg" *ngFor="let product of currentProductDetails">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                                               (change)="clickToRemove($event, product.productId)">
                                        <label class="form-check-label" for="flexCheckDefault">
                                            {{ product.productName }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="showEmptyError">
                                <span class="justify-content-center d-flex text-danger">No products found in this category</span>
                            </div>
                        </div>
                        <!--/.direct-chat-messages-->
                    </div>
                    <!-- /.card-body -->
                </div>
            </div>

            <div class="col-lg-6 col-12 mb-3">
                <div class="card direct-chat direct-chat-primary">
                    <div class="card-header ui-sortable-handle" style="cursor: move;">
                        <span class="text-danger">Please note: The products listed below have been removed from your shop.</span>

                        <!--<div class="card-tools">
                            <span title="3 New Messages" class="badge badge-primary">3</span>
                            <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                <i class="fas fa-minus"></i>
                            </button>
                            <button type="button" class="btn btn-tool" title="Contacts" data-widget="chat-pane-toggle">
                                <i class="fas fa-comments"></i>
                            </button>
                            <button type="button" class="btn btn-tool" data-card-widget="remove">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>-->
                    </div>
                    <!-- /.card-header -->
                    <div class="card-body">
                        <!-- Conversations are loaded here -->
                        <div class="direct-chat-messages">
                            <div *ngIf="removedProductDetails.length > 0">
                                <div *ngFor="let product of removedProductDetails; let i = index"
                                     class="direct-chat-msg">
                                    <span class="ml-2">{{i + 1}}. {{product.productName}}</span>
                                </div>
                            </div>
                            <div *ngIf="removedProductDetails.length == 0">
                                <span class="justify-content-center d-flex text-danger">No products selected for removal from your shop</span>
                            </div>
                        </div>
                        <!--/.direct-chat-messages-->
                    </div>
                    <!-- /.card-body -->
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-center align-items-center text-center mb-5">
            <button type="submit" class="btnColor">Click to Exclude</button>
        </div>
        <div class="d-flex justify-content-center align-items-center text-center mb-5"></div>
    </form>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium">
    <div class="loader">
        <div class="inner one"></div>
        <div class="inner two"></div>
        <div class="inner three"></div>
    </div>
</ngx-spinner>
